import { motion } from 'framer-motion';
import HeroAtAGlance from './HeroAtAGlance';
import ToolsOfTrade from '../skills/ToolsOfTrade';
import ThesisSpotlight from '../thesis/ThesisSpotlight';
import SectionHeading from '../home/SectionHeading';
import '../home/home.css';

const ease = [0.23, 1, 0.32, 1] as const;

const AboutSection = () => {
  return (
    <section className="home-section home-about-section" id="About">
      <div className="home-section-inner">
        <motion.div
          className="home-about-module"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease }}
        >
          <SectionHeading title="About" />

          <div className="home-section-body">
            <p className="home-about-paragraph">
              I&apos;m a software engineer working across product, systems, and
              applied research, currently building clinical trial supply-chain
              software at Prognosis. My background spans startups, fintech,
              healthcare, and academia, and I&apos;m most at home on technical
              problems where solid engineering has clear real-world impact.
            </p>
          </div>
        </motion.div>

        <HeroAtAGlance embedded />
        <ToolsOfTrade embedded />
        <ThesisSpotlight embedded />
      </div>
    </section>
  );
};

export default AboutSection;
